import React, {Component, ReactElement, ReactNode, RefObject} from 'react'
import {AdminPagePropsSet, createAdminPage} from '../../../../components/shared/hoc/createAdminPage'
import EventEmitterExAdmin from '../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {Nullable} from '../../../../app/TypeHelpers'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../../components/shared/hoc/withAdminPageTemplate'
import {NatApplicationRepo} from '../repository/NatApplicationRepo'
import {NatGetApplicationStatusDetail} from '../repository/NatGetApplicationStatus'
import {
    SecondaryTableCell,
    SecondaryTableRowName,
    StyledTableCaption,
    TableRowName,
    TableRowNameTop,
} from '../../../../styledComponents/adminPage/Table'
import {
    APPLY_CATEGORY,
    APPLY_IRREGULAR_PATTERN,
    MESSAGE_TYPE,
    RESIDENT_APPLY_PROCESS,
    RESIDENT_APPLY_STATUS,
    ROLE_FOR_ADMINISTRATOR,
} from '../../../../CodeMaster'
import {getApplicant} from '../common/helper/NatApplicationHelper'
import {BackLink, PrintLink, StyledLink} from '../../../../styledComponents/adminPage/Links'
import {Box, Table, TableBody, TableRow} from '@mui/material'
import moment from 'moment'
import {
    ApplyButtonTextWithIcon,
    ApplyReceptionOutlinedButton,
    ApplyRejectionOutlinedButton,
    DelegateApprovalButton,
    SpApplicationDetailInfoContent,
    SpApplicationDetailInfoContentName,
    SpApplicationDetailInfoContentValue,
    SpApplicationInfoArea,
    SpApplicationInfoFooter,
    SpApplyCategory,
    SpApplyStatusCell,
    SpBackLinkArea,
    SpDelegateApprovalButton,
    SpPageFooterArea,
    StyledTableCell,
} from '../common/admin/NatAdminApplicationCommon'
import NatAdminApplicationRejectionDialog from '../common/admin/NatAdminApplicationRejectionDialog'
import {Messages} from '../../../../Messages'
import {HeadingAreaMessageParams} from '../../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import NatAdminApplicationReceptionDialog from '../common/admin/NatAdminApplicationReceptionDialog'
import {NatApplicationStatusComponent} from '../common/admin/NatApplicationStatusComponent'
import {HKConstants} from '../../../../HKConstants'
import AuthorityChecker from '../../../../components/AuthorityChecker'
import {SessionStorageHelper} from '../../../../SessionStorageHelper'
import NatAdminApplicationApprovalDelegateDialog from '../common/admin/NatAdminApplicationApprovalDelegateDialog'
import NatAdminApplicationApprovalDirectorDelegateComponent
    from '../common/admin/NatAdminApplicationApprovalDirectorDelegateComponent'
import NatAdminApplicationApprovalDialog from '../common/admin/NatAdminApplicationApprovalDialog'
import styled from 'styled-components'
import {getFileExtension, getRandomKey, getStringOrEmptyString} from '../../../common/util/Natutil'
import {NatConstructionApplyDetail} from '../repository/NatGetConstructionApply'
import {
    NatPutRejectionConstructionApplyRequest,
    NatPutRejectionConstructionApplyResponse,
} from '../repository/NatPutRejectionConstructionApply'
import {
    NatPutApprovalsConstructionApplyRequest,
    NatPutApprovalsConstructionApplyResponse,
} from '../repository/NatPutApprovalsConstructionApply'
import {getFormattedAddress} from '../contactAddressOnEmergencies/helper/NatContactAddressOnEmergencyHelper'
import {
    FullWidthRowFlexContainer,
    LeftColumnFlexContainer,
    LeftRowFlexContainer,
    RightRowFlexContainer,
} from '../../../../styledComponents/FlexComponents'
import {NatFileApplyData} from '../repository/NatGetFileApply'
import {getLinkIconComponent} from '../../../../components/assocDirector/AssocDirectorCommon'
import {Colors} from '../../../../styledComponents/Constants'
import {NatConstructionApplicationDocument} from '../common/admin/print/NatConstructionApplicationDocument'
import ReactToPrint from 'react-to-print'
import {BlockSpacer} from '../../../../styledComponents/ResponsiveConvenience'
import {NatVehicleForConstructionDocument} from '../common/admin/print/NatVehicleForConstructionDocument'
import {NatAdminSpApplicationTabComponent} from '../common/admin/NatAdminSpApplicationTabComponent'
import {formatDateTimeWithoutSeconds} from '../../../../formatters/formatDate'
import {NatAdminSpApplicationPrintSelectDialog} from '../common/admin/NatAdminSpApplicationPrintSelectDialog'
import {Check, Close} from '@mui/icons-material'
import {AppAdminContext} from '../../../../app/AppAdminContext'
import {PrintContentArea} from '../common/admin/print/NatAdminApplicatioPrintCommonStyle'
import {NatAdminApplicationCommentToAssocDirector} from '../common/admin/NatAdminApplicationCommentToAssocDirector'
import {Location} from 'react-router-dom'

const KEY_LOGIN_USER_ROLE_ID: string = 'loginUserRoleId'

interface Props {
    condominiumCd: string
    applyId: string
    applicationRepo: NatApplicationRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    constructionApplyDetail: NatConstructionApplyDetail
    applicationStatusDetail: NatGetApplicationStatusDetail
    rejectionComment: string
    receptionComment: string
    approvalComment: string
    isLoadCompleted: boolean
    dialogStatus: Nullable<DialogContentType>
    actingChecked: boolean
    residentApplyProcess: RESIDENT_APPLY_PROCESS
}

type DialogContentType = 'reception' | 'rejection' | 'delegate' |
    'delegateApproval' | 'delegateRejection' | 'approval' | 'spPrint'

class NatAdminConstructionPage extends Component<Props & AdminPagePropsSet, States> {
    declare context: React.ContextType<typeof AppAdminContext>
    ownUrl: string
    applicationRef: RefObject<HTMLDivElement>
    vehicleForConstructionRef: RefObject<HTMLDivElement>
    roleId: Nullable<string>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.roleId = SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_USER_ROLE_ID)

        this.state = {
            constructionApplyDetail: {
                applyId: '',
                applyStatus: '',
                condominiumName: '',
                ridgeName: '',
                roomNumber: '',
                applicantFamilyName: '',
                applicantFirstName: '',
                applyDate: '',
                constructionContentDetail: '',
                constructionStartDate: '',
                constructionEndDate: '',
                contractorName: '',
                contractorZipCode: '',
                contractorPrefecture: '',
                contractorAddress2: '',
                contractorAddress3: '',
                contractorBuildingRoomNumber: '',
                contractorPhoneNumber: '',
                contractorRep: '',
                applyToAttachment: [],
                version: 0,
            },
            applicationStatusDetail: {
                applyStatusInfo: [],
            },
            rejectionComment: '',
            receptionComment: '',
            approvalComment: '',
            actingChecked: true,
            dialogStatus: null,
            isLoadCompleted: false,
            residentApplyProcess: RESIDENT_APPLY_PROCESS.RECEPTION,
        }

        this.ownUrl = this.props.location.pathname
        this.applicationRef = React.createRef()
        this.vehicleForConstructionRef = React.createRef()

        this.handleDialogCancelClick = this.handleDialogCancelClick.bind(this)
        this.handleReceptionClick = this.handleReceptionClick.bind(this)
        this.handleReceptionOkClick = this.handleReceptionOkClick.bind(this)
        this.handleRejectionClick = this.handleRejectionClick.bind(this)
        this.handleRejectionOkClick = this.handleRejectionOkClick.bind(this)
        this.handleApprovalClick = this.handleApprovalClick.bind(this)
        this.handleApprovalOkClick = this.handleApprovalOkClick.bind(this)
        this.handleDelegateClick = this.handleDelegateClick.bind(this)
        this.handleDelegateApprovalClick = this.handleDelegateApprovalClick.bind(this)
        this.handleDelegateApprovalOkClick = this.handleDelegateApprovalOkClick.bind(this)
        this.handleDelegateRejectionClick = this.handleDelegateRejectionClick.bind(this)
        this.handleDelegateRejectionOkClick = this.handleDelegateRejectionOkClick.bind(this)
        this.handleRejectionCommentChange = this.handleRejectionCommentChange.bind(this)
        this.handleReceptionCommentChange = this.handleReceptionCommentChange.bind(this)
        this.handleApprovalCommentChange = this.handleApprovalCommentChange.bind(this)
        this.onChangeActingChecked = this.onChangeActingChecked.bind(this)
        this.handleSpPrintLinkClick = this.handleSpPrintLinkClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            await this.getApplyInfo()
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
        this.showInitialMessage()
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    async getApplyInfo(): Promise<void> {
        const [constructionApplyResponse, applicationStatusResponse] = await Promise.all([
            this.getConstructionApply(),
            this.getApplicationStatus(),
        ])

        if (constructionApplyResponse && applicationStatusResponse) {
            const residentApplyProcess: RESIDENT_APPLY_PROCESS =
                constructionApplyResponse.applyStatus === RESIDENT_APPLY_STATUS.RECEPTION_WAITING.value
                    ? RESIDENT_APPLY_PROCESS.RECEPTION : RESIDENT_APPLY_PROCESS.ASSOC_DIRECTOR_APPROVAL
            this.setState({
                constructionApplyDetail: constructionApplyResponse,
                applicationStatusDetail: applicationStatusResponse,
                residentApplyProcess: residentApplyProcess,
            })
        }
    }

    async getConstructionApply(): Promise<Nullable<NatConstructionApplyDetail>> {
        const {condominiumCd, applyId, applicationRepo, eventEmitter} = this.props

        const response = await this.props.asyncCallFunction(
            applicationRepo.getConstructionApply.bind(applicationRepo, condominiumCd, applyId),
            (httpErrorOrNetworkError) => {
                eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        return response ? response.details : response
    }

    async getApplicationStatus(): Promise<Nullable<NatGetApplicationStatusDetail>> {
        const {condominiumCd, applyId, applicationRepo, eventEmitter} = this.props

        const response = await this.props.asyncCallFunction(
            applicationRepo.getApplicationStatus.bind(applicationRepo, condominiumCd, applyId),
            (httpErrorOrNetworkError) => {
                eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        return response ? response.details : response
    }

    handleDialogCancelClick(): void {
        this.setState({dialogStatus: null, actingChecked: true, receptionComment: '', approvalComment: ''})
    }

    handleReceptionClick(): void {
        this.setState({dialogStatus: 'reception'})
    }

    handleRejectionClick(): void {
        this.setState({dialogStatus: 'rejection'})
    }

    handleApprovalClick(): void {
        this.setState({dialogStatus: 'approval'})
    }

    handleDelegateClick(): void {
        this.setState({dialogStatus: 'delegate'})
    }

    handleDelegateApprovalClick(): void {
        this.setState({dialogStatus: 'delegateApproval'})
    }

    handleDelegateRejectionClick(): void {
        this.setState({dialogStatus: 'delegateRejection'})
    }

    onChangeActingChecked(checked: boolean): void {
        this.setState({actingChecked: !checked})
    }

    handleRejectionCommentChange(value: string): void {
        this.setState({rejectionComment: value})
    }

    handleReceptionCommentChange(value: string): void {
        this.setState({receptionComment: value})
    }

    handleApprovalCommentChange(value: string): void {
        this.setState({approvalComment: value})
    }

    async handleRejectionOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {residentApplyProcess, rejectionComment, constructionApplyDetail} = this.state

        const assocFlag = this.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutRejectionConstructionApplyRequest = {
                operation: residentApplyProcess.value,
                comment: rejectionComment,
                version: constructionApplyDetail.version,
            }

            const response: Nullable<NatPutRejectionConstructionApplyResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.rejectionConstructionApply
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                if (!assocFlag) {
                    this.props.navigate(`${this.ownUrl}`, {
                        replace: true,
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IPCDA0004.toString('申請'),
                            },
                            refreshToken: getRandomKey(),
                        },
                    })
                } else {
                    this.props.navigate('/admin/applications', {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IPCDA0006.toString(
                                    '申請',
                                    this.state.constructionApplyDetail.applyId,
                                    APPLY_CATEGORY.CONSTRUCTION_APPLY.label),
                            },
                        },
                    })
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleReceptionOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {residentApplyProcess, receptionComment, constructionApplyDetail} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutApprovalsConstructionApplyRequest = {
                operation: residentApplyProcess.value,
                comment: receptionComment,
                version: constructionApplyDetail.version,
            }

            const response: Nullable<NatPutApprovalsConstructionApplyResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.approvalConstructionApply
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    replace: true,
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0003.toString('申請'),
                        },
                        refreshToken: getRandomKey(),
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleApprovalOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {approvalComment, constructionApplyDetail, residentApplyProcess} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutApprovalsConstructionApplyRequest = {
                operation: residentApplyProcess.value,
                comment: approvalComment,
                version: constructionApplyDetail.version,
            }

            const response: Nullable<NatPutApprovalsConstructionApplyResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.approvalConstructionApply
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate('/admin/applications', {
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0005.toString(
                                '申請',
                                constructionApplyDetail.applyId,
                                APPLY_CATEGORY.CONSTRUCTION_APPLY.label),
                        },
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleDelegateApprovalOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {approvalComment, constructionApplyDetail, residentApplyProcess} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutApprovalsConstructionApplyRequest = {
                operation: residentApplyProcess.value,
                irregularPattern: APPLY_IRREGULAR_PATTERN.ASSOC_DIRECTOR_DELEGATE_APPROVAL.value,
                comment: approvalComment,
                version: constructionApplyDetail.version,
            }

            const response: Nullable<NatPutApprovalsConstructionApplyResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.approvalConstructionApply
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    replace: true,
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0007.toString('申請'),
                        },
                        refreshToken: getRandomKey(),
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleDelegateRejectionOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {rejectionComment, constructionApplyDetail} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutRejectionConstructionApplyRequest = {
                operation: RESIDENT_APPLY_PROCESS.ASSOC_DIRECTOR_APPROVAL.value,
                irregularPattern: APPLY_IRREGULAR_PATTERN.ASSOC_DIRECTOR_DELEGATE_APPROVAL.value,
                comment: rejectionComment,
                version: constructionApplyDetail.version,
            }

            const response: Nullable<NatPutRejectionConstructionApplyResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.rejectionConstructionApply
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    replace: true,
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0004.toString('申請'),
                        },
                        refreshToken: getRandomKey(),
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    handleSpPrintLinkClick(): void {
        this.setState({dialogStatus: 'spPrint'})
    }

    renderApplyToAttachment(attachmentList: NatFileApplyData[]): ReactNode {
        return attachmentList.map((attachment, index) => {
            return <AttachmentFileList key={`applyToAttachment-${index}`}>
                <StyledLink to={attachment.path}>
                    <LeftRowFlexContainer>
                        <AttachmentFileIconStyle>
                            {getLinkIconComponent(getFileExtension(attachment.fileName))}
                        </AttachmentFileIconStyle>
                        <AttachmentFileName>
                            {attachment.fileName}
                        </AttachmentFileName>
                    </LeftRowFlexContainer>
                </StyledLink>
            </AttachmentFileList>
        })
    }


    renderDetailsTable(): ReactNode {
        const {
            applyId,
            condominiumName,
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
            applyDate,
            constructionContentDetail,
            constructionStartDate,
            constructionEndDate,
            contractorName,
            contractorZipCode,
            contractorPrefecture,
            contractorAddress2,
            contractorAddress3,
            contractorBuildingRoomNumber,
            contractorPhoneNumber,
            contractorRep,
            applyToAttachment,
        } = this.state.constructionApplyDetail

        const address = getFormattedAddress(
            getStringOrEmptyString(contractorZipCode),
            getStringOrEmptyString(contractorPrefecture),
            getStringOrEmptyString(contractorAddress2),
            getStringOrEmptyString(contractorAddress3),
            getStringOrEmptyString(contractorBuildingRoomNumber),
        )

        const applicant = getApplicant(
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
        )

        return (
            <>
                <Table>
                    <StyledTableCaption>申請内容</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName>申請ID</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {applyId}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>申請区分</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {APPLY_CATEGORY.CONSTRUCTION_APPLY.label}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>申請者</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {condominiumName + '　' + applicant}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>申請日</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {moment(applyDate).format('YYYY年M月D日 H時m分')}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>工事内容</TableRowName>
                            <StyledTableCell colSpan={4}>
                                <Box whiteSpace={'pre-wrap'}>{constructionContentDetail}</Box>
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowNameTop rowSpan={2}>工事期間</TableRowNameTop>
                            <SecondaryTableCell colSpan={4}>
                                開始日：{moment(constructionStartDate).format('YYYY年M月D日')}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableCell colSpan={4} end>
                                終了日：{moment(constructionEndDate).format('YYYY年M月D日')}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowNameTop rowSpan={4}>工事施工者</TableRowNameTop>
                            <SecondaryTableRowName>
                                業者名
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {contractorName}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableRowName>
                                住所
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {address}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableRowName>
                                電話番号
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {contractorPhoneNumber}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableRowName end>
                                担当者
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3} end>
                                {contractorRep}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow style={{verticalAlign: 'text-top'}}>
                            <TableRowName>添付資料</TableRowName>
                            <StyledTableCell colSpan={4}>
                                <LeftColumnFlexContainer>
                                    {this.renderApplyToAttachment(applyToAttachment)}
                                </LeftColumnFlexContainer>
                            </StyledTableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </>
        )
    }

    renderPageHeaderArea(): ReactNode {
        const {constructionApplyDetail, applicationStatusDetail} = this.state

        return (
            <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPLICATION_PRINT_APPLICATION}>
                <Box mt={'20px'}>
                    <RightRowFlexContainer>
                        <ReactToPrint
                            trigger={() => (
                                <PrintLink>
                                    <Box ml={'10px'}>
                                        申請書を印刷する
                                    </Box>
                                </PrintLink>
                            )}
                            content={() => this.applicationRef.current}
                        />
                        <PrintContentArea>
                            <div ref={this.applicationRef}>
                                <NatConstructionApplicationDocument
                                    constructionApplicationDocumentParam={constructionApplyDetail}
                                    applyStatusInfoList={applicationStatusDetail.applyStatusInfo}
                                />
                            </div>
                        </PrintContentArea>
                        {constructionApplyDetail.applyStatus === RESIDENT_APPLY_STATUS.COMPLETE.value &&
                            <>
                                <BlockSpacer width={42}/>
                                <ReactToPrint
                                    trigger={() => (
                                        <PrintLink>
                                            <Box ml={'10px'}>
                                                工事用車両標識を印刷する
                                            </Box>
                                        </PrintLink>
                                    )}
                                    pageStyle={'@page { size: landscape; margin: 0;}'}
                                    content={() => this.vehicleForConstructionRef.current}/>
                                <PrintContentArea>
                                    <div ref={this.vehicleForConstructionRef}>
                                        <NatVehicleForConstructionDocument
                                            condominiumName={constructionApplyDetail.condominiumName}
                                            ridgeName={constructionApplyDetail.ridgeName}
                                            roomNumber={constructionApplyDetail.roomNumber}
                                            phoneNumber={constructionApplyDetail.contractorPhoneNumber}
                                            constructionStartDate={constructionApplyDetail.constructionStartDate}
                                            constructionEndDate={constructionApplyDetail.constructionEndDate}
                                        />
                                    </div>
                                </PrintContentArea>
                            </>
                        }
                    </RightRowFlexContainer>
                </Box>
            </AuthorityChecker>
        )
    }

    renderPageFooterArea(): ReactNode {
        const {constructionApplyDetail} = this.state

        return (
            <>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={() => this.props.navigate(
                            `/admin/applications`,
                        )}
                    >
                        申請状況一覧に戻る
                    </BackLink>
                </PageFotterAreaLeft>
                {(constructionApplyDetail.applyStatus === RESIDENT_APPLY_STATUS.ASSOC_DIRECTOR_WAITING.value) &&
                    <PageFotterAreaRight>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPROVAL_DELEGATE_APPLICATION}>
                            <DelegateApprovalButton onClick={this.handleDelegateClick}>
                                この申請の承認操作を代行する
                            </DelegateApprovalButton>
                        </AuthorityChecker>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPROVAL_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><Box ml={'8px'}/>却下する
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleApprovalClick}>
                                <Check/><Box ml={'8px'}/>承認する
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </PageFotterAreaRight>
                }
                {(constructionApplyDetail.applyStatus === RESIDENT_APPLY_STATUS.RECEPTION_WAITING.value) &&
                    <PageFotterAreaRight>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.RECEPTION_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><Box ml={'8px'}/>却下する
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleReceptionClick}>
                                <Check/><Box ml={'8px'}/>受け付ける
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </PageFotterAreaRight>
                }
            </>
        )
    }

    renderPc(): ReactNode {
        return (
            <>
                <Box mb={'20px'}>
                    {this.renderPageHeaderArea()}
                </Box>
                <PageMainArea>
                    {this.renderDetailsTable()}
                    <NatApplicationStatusComponent
                        currentApplyStatus={this.state.constructionApplyDetail.applyStatus}
                        applyStatusInfoList={this.state.applicationStatusDetail.applyStatusInfo}
                    />
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }

    renderSpApplicantInfo(): ReactNode {
        const {constructionApplyDetail, applicationStatusDetail} = this.state
        const {
            applyId,
            condominiumName,
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
            applyDate,
            applyStatus,
        } = constructionApplyDetail

        const applicant = getApplicant(
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
        )

        return (
            <SpApplicationInfoArea>
                <LeftColumnFlexContainer>
                    <div>{applyId}</div>
                    <FullWidthRowFlexContainer>
                        <SpApplyCategory>
                            {APPLY_CATEGORY.CONSTRUCTION_APPLY.label}
                        </SpApplyCategory>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPLICATION_PRINT_APPLICATION}>
                            {constructionApplyDetail.applyStatus === RESIDENT_APPLY_STATUS.COMPLETE.value ?
                                <PrintLink onClick={this.handleSpPrintLinkClick}>
                                    <Box ml={'10px'}>
                                        印刷する
                                    </Box>
                                </PrintLink>
                                :
                                <>
                                    <ReactToPrint
                                        trigger={() => (
                                            <PrintLink>
                                                <Box ml={'10px'}>
                                                    印刷する
                                                </Box>
                                            </PrintLink>
                                        )}
                                        content={() => this.applicationRef.current}/>
                                    <PrintContentArea>
                                        <div ref={this.applicationRef}>
                                            <NatConstructionApplicationDocument
                                                constructionApplicationDocumentParam={constructionApplyDetail}
                                                applyStatusInfoList={applicationStatusDetail.applyStatusInfo}
                                            />
                                        </div>
                                    </PrintContentArea>
                                </>}
                        </AuthorityChecker>
                    </FullWidthRowFlexContainer>
                    <Box pt={'12px'}>
                        <div>{condominiumName}</div>
                        <div>{applicant}</div>
                    </Box>
                    <Box height={'12px'}/>
                    <SpApplicationInfoFooter>
                        <div>
                            {formatDateTimeWithoutSeconds(applyDate)} に提出
                        </div>
                        <SpApplyStatusCell status={applyStatus}>
                            {RESIDENT_APPLY_STATUS.codeToEnumConstants(applyStatus).label}
                        </SpApplyStatusCell>
                    </SpApplicationInfoFooter>
                </LeftColumnFlexContainer>
            </SpApplicationInfoArea>
        )
    }

    renderSpPageFooterArea(): ReactNode {
        const {applyStatus} = this.state.constructionApplyDetail
        return (
            <>
                {(applyStatus === RESIDENT_APPLY_STATUS.ASSOC_DIRECTOR_WAITING.value) &&
                    <SpPageFooterArea>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPROVAL_DELEGATE_APPLICATION}>
                            <SpDelegateApprovalButton onClick={this.handleDelegateClick}>
                                この申請の承認操作を代行する
                            </SpDelegateApprovalButton>
                        </AuthorityChecker>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPROVAL_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><ApplyButtonTextWithIcon>却下する</ApplyButtonTextWithIcon>
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleApprovalClick}>
                                <Check/><ApplyButtonTextWithIcon>承認する</ApplyButtonTextWithIcon>
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </SpPageFooterArea>
                }
                {(applyStatus === RESIDENT_APPLY_STATUS.RECEPTION_WAITING.value) &&
                    <SpPageFooterArea>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.RECEPTION_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><ApplyButtonTextWithIcon>却下する</ApplyButtonTextWithIcon>
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleReceptionClick}>
                                <Check/><ApplyButtonTextWithIcon>受け付ける</ApplyButtonTextWithIcon>
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </SpPageFooterArea>
                }
            </>
        )
    }

    renderSpCommentToAssocDirector(): ReactNode {
        const {constructionApplyDetail, applicationStatusDetail} = this.state
        if (constructionApplyDetail.applyStatus !== RESIDENT_APPLY_STATUS.ASSOC_DIRECTOR_WAITING.value) {
            return null
        }

        const commentToAssocDirectorInfo = applicationStatusDetail.applyStatusInfo
            .find(status => status.applyProcess === RESIDENT_APPLY_PROCESS.RECEPTION.value)
            ?.actual

        if (!(commentToAssocDirectorInfo?.comment)) {
            return null
        }

        return <Box pb={'16px'}>
            <NatAdminApplicationCommentToAssocDirector
                comment={commentToAssocDirectorInfo.comment}
                roleId={commentToAssocDirectorInfo.roleId}
                familyName={commentToAssocDirectorInfo.familyName}
                firstName={commentToAssocDirectorInfo.firstName}
                registerDatetime={commentToAssocDirectorInfo.registerDatetime}
            />
        </Box>
    }

    renderSpApplicationDetailInfo(): ReactNode {
        const {
            constructionContentDetail,
            constructionStartDate,
            constructionEndDate,
            contractorName,
            contractorZipCode,
            contractorPrefecture,
            contractorAddress2,
            contractorAddress3,
            contractorBuildingRoomNumber,
            contractorPhoneNumber,
            contractorRep,
            applyToAttachment,
        } = this.state.constructionApplyDetail

        const address = getFormattedAddress(
            getStringOrEmptyString(contractorZipCode),
            getStringOrEmptyString(contractorPrefecture),
            getStringOrEmptyString(contractorAddress2),
            getStringOrEmptyString(contractorAddress3),
            getStringOrEmptyString(contractorBuildingRoomNumber),
        )

        return (
            <>
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>工事内容</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        <Box whiteSpace={'pre-wrap'}>
                            {constructionContentDetail}
                        </Box>
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>工事期間</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        開始日：{moment(constructionStartDate).format('YYYY年M月D日')}
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        終了日：{moment(constructionEndDate).format('YYYY年M月D日')}
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>工事施工者</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        業者名：{contractorName}
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        住所：{address}
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        電話番号：{contractorPhoneNumber}
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        担当者：{contractorRep}
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>添付資料</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        {this.renderApplyToAttachment(applyToAttachment)}
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
                {this.renderSpPageFooterArea()}
            </>
        )
    }

    renderSpApplicationStatusInfo(): ReactNode {
        return (
            <NatApplicationStatusComponent
                currentApplyStatus={this.state.constructionApplyDetail.applyStatus}
                applyStatusInfoList={this.state.applicationStatusDetail.applyStatusInfo}
            />
        )
    }

    renderSp(): ReactNode {
        return (
            <>
                <SpBackLinkArea>
                    <BackLink
                        onClick={() => this.props.navigate(
                            `/admin/applications`,
                        )}
                    >
                        申請状況一覧
                    </BackLink>
                </SpBackLinkArea>
                {this.renderSpApplicantInfo()}
                <Box height={'16px'}/>
                {this.renderSpCommentToAssocDirector()}
                <NatAdminSpApplicationTabComponent
                    detailInfo={this.renderSpApplicationDetailInfo()}
                    statusInfo={this.renderSpApplicationStatusInfo()}
                />
                <Box height={`32px`}/>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        const {constructionApplyDetail, applicationStatusDetail} = this.state
        if (!this.state.isLoadCompleted) {
            return null
        }

        const spMode = this.context.showSpModePage

        return (
            <>
                {spMode ? this.renderSp() : this.renderPc()}
                <NatAdminApplicationRejectionDialog
                    open={this.state.dialogStatus === 'rejection'}
                    residentApplyProcess={this.state.residentApplyProcess}
                    onCancel={this.handleDialogCancelClick}
                    onRejection={this.handleRejectionOkClick}
                    onChange={this.handleRejectionCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationReceptionDialog
                    open={this.state.dialogStatus === 'reception'}
                    onCancel={this.handleDialogCancelClick}
                    onReception={this.handleReceptionOkClick}
                    eventEmitter={this.props.eventEmitter}
                    onChange={this.handleReceptionCommentChange}
                    commentFormRequired={true}
                />
                <NatAdminApplicationApprovalDialog
                    open={this.state.dialogStatus === 'approval'}
                    residentApplyProcess={this.state.residentApplyProcess}
                    onApproval={this.handleApprovalOkClick}
                    onCancel={this.handleDialogCancelClick}
                    onChange={this.handleApprovalCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationApprovalDelegateDialog
                    open={this.state.dialogStatus === 'delegate'}
                    delegateComponent={<NatAdminApplicationApprovalDirectorDelegateComponent
                        onChange={this.onChangeActingChecked}/>}
                    rejectionButtonDisabled={this.state.actingChecked}
                    approvalButtonDisabled={this.state.actingChecked}
                    onApproval={this.handleDelegateApprovalClick}
                    onRejection={this.handleDelegateRejectionClick}
                    onCancel={this.handleDialogCancelClick}
                />
                <NatAdminApplicationApprovalDialog
                    open={this.state.dialogStatus === 'delegateApproval'}
                    residentApplyProcess={this.state.residentApplyProcess}
                    applyIrregularPattern={APPLY_IRREGULAR_PATTERN.ASSOC_DIRECTOR_DELEGATE_APPROVAL}
                    onApproval={this.handleDelegateApprovalOkClick}
                    onCancel={this.handleDialogCancelClick}
                    onChange={this.handleApprovalCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationRejectionDialog
                    open={this.state.dialogStatus === 'delegateRejection'}
                    residentApplyProcess={this.state.residentApplyProcess}
                    applyIrregularPattern={APPLY_IRREGULAR_PATTERN.ASSOC_DIRECTOR_DELEGATE_APPROVAL}
                    onCancel={this.handleDialogCancelClick}
                    onRejection={this.handleDelegateRejectionOkClick}
                    onChange={this.handleRejectionCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminSpApplicationPrintSelectDialog
                    open={this.state.dialogStatus === 'spPrint'}
                    onCancel={this.handleDialogCancelClick}
                    firstDocument={<NatConstructionApplicationDocument
                        constructionApplicationDocumentParam={constructionApplyDetail}
                        applyStatusInfoList={applicationStatusDetail.applyStatusInfo}
                    />}
                    firstDocumentName={'申請書'}
                    secondDocument={<NatVehicleForConstructionDocument
                        condominiumName={constructionApplyDetail.condominiumName}
                        ridgeName={constructionApplyDetail.ridgeName}
                        roomNumber={constructionApplyDetail.roomNumber}
                        phoneNumber={constructionApplyDetail.contractorPhoneNumber}
                        constructionStartDate={constructionApplyDetail.constructionStartDate}
                        constructionEndDate={constructionApplyDetail.constructionEndDate}
                    />}
                    secondDocumentName={'工事用車両標識'}
                    secondDocumentPageOrientation={'landscape'}
                />
            </>
        )
    }
}

NatAdminConstructionPage.contextType = AppAdminContext
export default createAdminPage(NatAdminConstructionPage)

const AttachmentFileName = styled.div`
  overflow-wrap: anywhere;
`

const AttachmentFileList = styled.div`
  :not(:first-child) {
    padding-top: 16px;
  }
`

const AttachmentFileIconStyle = styled.div`
  font-size: 21px;
  line-height: 1;
  min-width: 21px;
  text-align: center;
  margin-right: 8px;
  color: ${Colors.AccentDark};
`
